export default __webpack_public_path__ + "static/media/test2.56535809.svg";